import React from 'react'
import { Skeleton } from 'antd'
import './Loader.styles.scss'

const PayeeDetailsLoader: React.FC = () => {
  return (
    <div
      style={{
        display: 'grid',
        gap: '3rem',
        paddingTop: '2%',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '10%',
          width: '80%',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
      </div>
      <div
        style={{
          display: 'grid',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '65%' }} />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '10%',
          width: '80%',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
      </div>
    </div>
  )
}

export default PayeeDetailsLoader
